import WebApp from '@twa-dev/sdk';

import { INIT_URL_SESSION_KEY } from '../constants';
import { logErrorMini } from '../services/service-logger/lib/log-error-mini';
import { type StartAppArgs } from '../store/tg-store/types';
import { base64Utils } from './base64-utils';

const getParamFromUrl = (search: string) => {
  const urlSearch = new URLSearchParams(search);
  // The startapp parameter appears when opening via keyboard button.
  // It contains what was originally put in it when creating the button.
  // This is a crutch replacement for initData, which is missing when opening via keyboard button
  // https://core.telegram.org/bots/webapps#implementing-mini-apps
  const encodedQuery = urlSearch.get('startapp');

  return encodedQuery;
};

export const getDecodedStartappQuery = (): StartAppArgs => {
  let args = {} as StartAppArgs;

  try {
    let encodedQuery = getParamFromUrl(window.location.search);
    const encodedTGParams = WebApp?.initDataUnsafe?.start_param;

    if (!encodedQuery) {
      const initUrl = sessionStorage.getItem(INIT_URL_SESSION_KEY);

      if (initUrl) {
        encodedQuery = getParamFromUrl(new URL(initUrl).search);
      }
    }

    const encodedArgs = encodedQuery || encodedTGParams;

    if (encodedArgs) {
      args = base64Utils.decode<StartAppArgs>(encodedArgs);
    }
  } catch (err) {
    void logErrorMini(err as Error, 'getDecodedStartappQuery');
    console.error(err);
  }

  return args;
};
